import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

import type { GenerateAiPetitionImageBackgroundMutation } from './api.graphql';

type ResponseError = Extract<
	GenerateAiPetitionImageBackgroundMutation['generateAiPetitionImage'],
	{ __typename: 'GenerateAiPetitionImageBackgroundError' }
>['__typename'];

const ERROR_TYPES = {
	GenerateAiPetitionImageBackgroundError: 'generate_ai_petition_image_background_error',
} satisfies Record<ResponseError, string>;

export class GenerateAiPetitionImageBackgroundError extends CustomError {
	readonly code?: string;

	constructor(error?: string, options?: ErrorOptions) {
		super(
			error === 'GenerateAiPetitionImageBackgroundError'
				? `SAP3: Failed to generate AI Image: ${ERROR_TYPES[error]}`
				: 'SAP3: Failed to generate AI Image',
			options,
		);

		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		this.code = error && error in ERROR_TYPES ? ERROR_TYPES[error as ResponseError] : undefined;
	}
}
setClassName(GenerateAiPetitionImageBackgroundError, 'GenerateAiPetitionImageBackgroundError');
